//#region src/ncr_aloha_order_mode.ts
var NcrAlohaOrderMode = /* @__PURE__ */ function(NcrAlohaOrderMode) {
	NcrAlohaOrderMode["CallIn"] = "CallIn";
	NcrAlohaOrderMode["WalkIn"] = "WalkIn";
	NcrAlohaOrderMode["Web"] = "Web";
	NcrAlohaOrderMode["Delivery"] = "Delivery";
	NcrAlohaOrderMode["Curbside"] = "Curbside";
	NcrAlohaOrderMode["EatIn"] = "EatIn";
	NcrAlohaOrderMode["DriveThru"] = "DriveThru";
	NcrAlohaOrderMode["Catering"] = "Catering";
	NcrAlohaOrderMode["FaxedIn"] = "FaxedIn";
	NcrAlohaOrderMode["None"] = "None";
	return NcrAlohaOrderMode;
}(NcrAlohaOrderMode || {});
//#endregion
export { NcrAlohaOrderMode };

//# sourceMappingURL=ncr_aloha_order_mode.js.map